/* BELORA — SKIMS PURE · collection behaviour.
   SKIMS paginates with a "Load More" control — not infinite scroll, not page
   numbers. This progressively enhances the real <a href="?page=N">, so the page
   still works with JavaScript off. */
(function () {
  'use strict';

  var wrap = document.querySelector('[data-sk-more]');
  var grid = document.querySelector('[data-sk-grid]');
  if (!wrap || !grid) return;

  var busy = false;

  wrap.addEventListener('click', function (event) {
    var link = event.target.closest('[data-sk-more-link]');
    if (!link || busy) return;
    event.preventDefault();

    busy = true;
    var href = link.getAttribute('href');
    link.setAttribute('aria-busy', 'true');

    fetch(href)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-sk-grid]');
        var nextLink = doc.querySelector('[data-sk-more-link]');
        var addedCount = 0;

        if (nextGrid) {
          var added = Array.prototype.slice.call(nextGrid.children);
          addedCount = added.length;
          added.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        }

        // Move focus to the first newly added card, or a keyboard user is
        // dumped back at the top of the list after every Load More.
        if (addedCount) {
          var first = grid.children[grid.children.length - addedCount];
          var focusable = first && first.querySelector('a');
          if (focusable) {
            focusable.setAttribute('tabindex', '-1');
            focusable.focus({ preventScroll: true });
          }
        }

        if (nextLink) {
          link.setAttribute('href', nextLink.getAttribute('href'));
        } else {
          wrap.remove();
        }
        try { window.history.replaceState({}, '', href); } catch (e) {}
      })
      .catch(function () { window.location.href = href; })
      .then(function () {
        busy = false;
        link.removeAttribute('aria-busy');
      });
  });
})();

/* Search facet row: a facet name opens the facets drawer (Prestige opens it
   from aria-controls) and this unfolds that one group and brings it into view,
   so the name the customer pressed is the list they see. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sk-facet]');
    if (!b) return;
    var name = b.getAttribute('data-sk-facet');
    window.setTimeout(function () {
      var drawer = document.getElementById('facets-drawer');
      if (!drawer) return;
      var groups = drawer.querySelectorAll('accordion-disclosure');
      for (var i = 0; i < groups.length; i++) {
        var sum = groups[i].querySelector('summary');
        if (sum && sum.textContent.trim() === name) {
          var d = groups[i].querySelector('details');
          if (d && !d.open) sum.click();
          groups[i].scrollIntoView({ block: 'nearest' });
          break;
        }
      }
    }, 60);
  });
})();

/* Filter drawer: the status line counts the choices as they are made, and the
   button shows how many products those choices really leave — Shopify's own
   answer for the section at the form's current URL, not an estimate. */
(function () {
  'use strict';
  var timer = null, ctrl = null;
  function chosen(form) {
    var n = 0, price = false;
    new FormData(form).forEach(function (v, k) {
      if (!/^filter\./.test(k) || v === '') return;
      if (/^filter\.v\.price\./.test(k)) price = true; else n++;
    });
    return n + (price ? 1 : 0);
  }
  function urlFor(ff) {
    var form = ff.querySelector('form');
    var url = new URL(form.action, window.location.href);
    url.search = '';
    new URLSearchParams(new FormData(form)).forEach(function (v, k) {
      if ((k === 'page' || k === 'filter.v.price.gte' || k === 'filter.v.price.lte') && v === '') return;
      url.searchParams.append(k, v);
    });
    url.searchParams.set('section_id', ff.getAttribute('section-id'));
    return url.toString();
  }
  document.addEventListener('change', function (e) {
    var ff = e.target.closest && e.target.closest('.sk-fdrawer facets-form');
    if (!ff) return;
    var drawer = ff.closest('.sk-fdrawer');
    var st = drawer.querySelector('[data-sk-fstatus]');
    var n = chosen(ff.querySelector('form'));
    if (st) st.textContent = n ? st.getAttribute('data-some').replace('[count]', n) : st.getAttribute('data-none');
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      if (ctrl) ctrl.abort();
      ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      fetch(urlFor(ff), ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var c = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sk-count]');
          var btn = drawer.querySelector('[data-sk-fapply]');
          if (c && btn) btn.textContent = btn.getAttribute('data-label').replace('[count]', c.getAttribute('data-sk-count'));
        })
        .catch(function () {});
    }, 250);
  });
})();

/* ==========================================================================
   Back to top (collection pages). Measured on the reference (vfr-backtop-sk):
   the control is evaluated once scrolling has been idle for ~0.4s — shown when
   that burst moved the page UP or ended at the page's end, removed when it
   moved DOWN or ended near the top. A click glides to the top.
   ========================================================================== */
(function () {
  'use strict';
  var btn = document.querySelector('[data-sk-backtop]');
  if (!btn) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var IDLE = 400;          // ms of quiet before the burst is read
  var TOP = 200;           // px — near the top it is never shown
  var burstFrom = null;
  var timer = null;

  function settle() {
    var y = window.scrollY;
    var end = y + window.innerHeight >= document.documentElement.scrollHeight - 2;
    var moved = burstFrom === null ? 0 : y - burstFrom;
    burstFrom = null;
    if (y < TOP) { btn.hidden = true; return; }
    if (end || moved < 0) { btn.hidden = false; return; }
    if (moved > 0) btn.hidden = true;
  }

  window.addEventListener('scroll', function () {
    if (burstFrom === null) burstFrom = lastY;
    lastY = window.scrollY;
    window.clearTimeout(timer);
    timer = window.setTimeout(settle, IDLE);
  }, { passive: true });
  var lastY = window.scrollY;

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduced.matches ? 'auto' : 'smooth' });
    // Keyboard users land on the page's heading rather than on nothing.
    var h = document.querySelector('.sk-collection__title, .sk-search__title, main h1');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  });
})();

/* ---------------------------------------------------------------- sort ---
   The reference has both toolbar controls open the SAME drawer, and its Sort
   row is the first group inside it (measured 12 Sep 2026). Our toolbar button
   opens that drawer; this unfolds the Sort group when the shopper arrived
   through it, so the choice they asked for is the one in front of them. */
(function () {
  var btn = document.querySelector("[data-sk-open-sort]");
  var drawer = document.getElementById("facets-drawer");
  if (!btn || !drawer) return;
  btn.addEventListener("click", function () {
    // The drawer opens on its own (aria-controls); wait for it to be there.
    window.setTimeout(function () {
      /* The row is <accordion-disclosure class="accordion"><details><summary>. Querying
         "details, .accordion" matched the WRAPPER first — it carries .accordion and comes first in
         document order — and the wrapper holds no button: its toggle is a <summary>. So the row
         never opened, which vfr-be-plpbar caught. Take the <details> itself and click its summary,
         which lets the component's own show animation run instead of snapping the attribute. */
      var first = drawer.querySelector("details.accordion__disclosure, details");
      if (!first || first.open) return;
      var sum = first.querySelector("summary");
      if (sum) sum.click(); else first.open = true;
    }, 120);
  });
})();

/* ------------------------------------------------- filter drawer motion ---
   The reference does NOT slide its filter drawer in the way it slides the bag:
   the panel FADES while nudging 32px (opacity 0->1, translateX 32->0, 300ms
   ease-out) over a scrim that fades with it, and reverses on close (sampled
   frame by frame at 1440 and 390, 12 Sep 2026 — vfr-motion-plp). Prestige
   animates every drawer with a full-width slide, so this replaces the enter
   and leave animations for THIS drawer only, and falls back to Prestige's own
   if anything is missing. The caller only needs a .finished promise. */
(function () {
  var FD = window.customElements && window.customElements.get("facets-drawer");
  if (!FD || FD.__skNudge) return;
  var proto = FD.prototype;
  var origIn = proto.createEnterAnimationControls;
  var origOut = proto.createLeaveAnimationControls;
  if (typeof origIn !== "function" || typeof origOut !== "function") return;
  FD.__skNudge = true;
  var EASE = "cubic-bezier(0, 0, .2, 1)";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  function dur() { return reduced.matches ? 1 : 300; }
  function play(el, frames) { return el.animate(frames, { duration: dur(), easing: EASE, fill: "both" }); }
  proto.createEnterAnimationControls = function () {
    try {
      var overlay = this.getShadowPartByName("overlay");
      var content = this.getShadowPartByName("content");
      if (!overlay || !content || !content.animate) return origIn.call(this);
      /* Prestige sets this INSIDE its own enter animation, which is why replacing that method
         moved the panel to the left edge: without it the content keeps margin-inline-start 0.
         The reference's filter panel is right-aligned (450x900 at x=990 of 1440), so the side has
         to be restored here. Caught by reading the content part itself — the frame sampler reads
         slotted children and cannot see which side the part is on. */
      content.style.marginInlineStart = this.openFrom === "right" ? "auto" : 0;
      var a = play(overlay, { opacity: [0, 1] });
      var b = play(content, { opacity: [0, 1], transform: ["translateX(32px)", "translateX(0)"] });
      return { finished: Promise.all([a.finished, b.finished]) };
    } catch (e) { return origIn.call(this); }
  };
  proto.createLeaveAnimationControls = function () {
    try {
      var overlay = this.getShadowPartByName("overlay");
      var content = this.getShadowPartByName("content");
      if (!overlay || !content || !content.animate) return origOut.call(this);
      var a = play(overlay, { opacity: [1, 0] });
      var b = play(content, { opacity: [1, 0], transform: ["translateX(0)", "translateX(32px)"] });
      return { finished: Promise.all([a.finished, b.finished]) };
    } catch (e) { return origOut.call(this); }
  };
})();
